import { createContext } from 'react';

export const globalModalInitState = {
  isShow: false,
};

export const globalModalActionType = {
  OPEN_MODAL: 'OPEN_MODAL',
  CLOSE_MODAL: 'CLOSE_MODAL',
};

export const globalModalReducer = (state = globalModalInitState, action) => {
  switch (action.type) {
    case globalModalActionType.OPEN_MODAL:
      return {
        isOpen: true,
        ...action.payload,
      };
    case globalModalActionType.CLOSE_MODAL:
      return {
        isOpen: false,
      };
    default:
      return state;
  }
};

export const globalModalContext = createContext({});
